import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import GlobalFilterPanel, {FILTER_PERIOD_GROUP} from '../filter/GlobalFilterPanel';
import DateRange from '../selectors/date/DateRange';
import AppConfig from '../../utils/appConfig';

const log = new Logger('PROCESSED_DOCUMENTS_FILTER_PANEL', LOG_LEVELS.DEBUG);

export class ProcessedDocumentsFilterPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selection: {
        manualDocumentsOnly: false,
        startDate: '',
        endDate: ''
      }
    };
    this.onSearchClick = this.onSearchClick.bind(this);
    this.dateRangeChangeHandler = this.dateRangeChangeHandler.bind(this);
  }

  onSearchClick(selection) {
    log.debug('onSearchClick(): state.selection: ', this.state.selection);
    log.debug('onSearchClick(): selection: ', selection);
    let combinedSelection = Object.assign({}, selection, this.state.selection);
    log.debug('onSearchClick(): combinedSelection: ', combinedSelection);
    this.props.onSearchClick(combinedSelection);
  }
  
  filterSelectionHandler(fieldName) {
    return (evt) => {
      log.debug('filterSelectionHandler(%s): ', fieldName, evt.target.value);
      let selection = Object.assign({}, this.state.selection);
      if(_.isEmpty(`${evt.target.value}`)) {
        delete selection[fieldName];
      } else {
        selection[fieldName] = evt.target.value;
      }
      this.setState({
        selection: selection
      });
    };
  }

  dateRangeChangeHandler(keyValue) {
    log.debug('dateRangeChangeHandler(): keyValue: ', keyValue);
    let selection = Object.assign({}, this.state.selection);
    let key =  Object.keys(keyValue)[0];
    let value =  Object.values(keyValue)[0];
    if(_.isEmpty(value)) {
      delete selection[key];
    } else {
      selection = Object.assign(selection, keyValue);
    }
    this.setState({
      selection: selection
    });
  }

  checkboxChangeHandlerFactory(fieldName) {
    return (event) => {
      log.debug('checkboxChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, event.target.checked, event);
      let selection = Object.assign({}, this.state.selection);
      selection[fieldName] = event.target.checked;
      this.setState({
        selection: selection
      });
    };
  }

  render() {
    log.debug('render(): ', this.props);
    const {selection={}} = this.state;
    const globalFilterSetting = {
      hideElements: {
        countryCode: true,
        month: true,
        year: true,
        startDate: true,
        endDate: true,
        returnType: true,
        returnStatus: true
      },    
      filterPeriodGroup: FILTER_PERIOD_GROUP.DATE_RANGE,      
      onSearchClick: this.onSearchClick,
      searchLabelLanguageString: 'globalFilterPanel_search',
      companySelectValueLanguageStringKey: 'global_All',
      labelElements: {
        startDate: 'processedDocumentsFilterPanel_processedAfter',
        endDate: 'processedDocumentsFilterPanel_processedBefore'
      }
    };
    return (
      <s-box name="filter-panel">
        <GlobalFilterPanel {...globalFilterSetting}>
          <DateRange  
            onChange={this.dateRangeChangeHandler} 
            startDate={selection.startDate} 
            endDate={selection.endDate} 
            startDateLabelkey='processedDocumentsFilterPanel_processedAfter'
            endDateLabelkey='processedDocumentsFilterPanel_processedBefore'
          />
          <fieldset>
            <label><LanguageStringResolver string='processedDocumentsFilterPanel_filenameContains'/></label>
            <input type="text" value={selection.filename} onChange={this.filterSelectionHandler('filename')} />     
          </fieldset>
          <fieldset>
            <legend><LanguageStringResolver string='processedDocumentsFilterPanel_onlyShowManualDocuments'/></legend>
            <span className="clear"></span>
            <input type="checkbox" checked={`${selection.manualDocumentsOnly}` === 'true'} onChange={this.checkboxChangeHandlerFactory('manualDocumentsOnly')}  />
            <label className="checkbox"><LanguageStringResolver string='processedDocumentsFilterPanel_onlyShowManualDocuments_true'/></label>
          </fieldset>
        </GlobalFilterPanel>
        <div className="clear"></div>
      </s-box>
    )
  }

  componentDidMount() {
    let seletion = {};
    if(!_.isEmpty(this.props.filterOption)) {
      seletion = this.props.filterOption
    }
    let todaysDate = new Date(); 
    if(!seletion.startDate) {
      seletion.startDate  = moment.utc(todaysDate).startOf('month').format(AppConfig.DateTimeConfig.DEFAULT_MOMENT_DATE_FORMAT);
    }
    if(!seletion.endDate) {
      seletion.endDate = moment.utc(todaysDate).endOf('month').format(AppConfig.DateTimeConfig.DEFAULT_MOMENT_DATE_FORMAT);
    }
    this.setState({
      selection: seletion
    });
  }

  componentDidUpdate(prevProps) {
    if(this.props.filterOption !== prevProps.filterOption) {
      this.setState({
        selection: Object.assign({}, this.state.selection, this.props.filterOption)
      });
    }
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


ProcessedDocumentsFilterPanel.defaultProps = {
  onSearchClick: () => {},
  filterOption: {}
};

export default connect(mapStateToProps)(ProcessedDocumentsFilterPanel);